<template>
    <div class="pricing-plan">
        <h3 class="margin-top-100">Struggling to find the right talent?</h3>

        <!-- <p class="margin-top-10">
        </p> -->
        <!-- <div class="pricing-plan-label billed-monthly-label skeleton">
            <template>
                <strong></strong>
            </template>
</div> -->
        <!-- <div class="pricing-plan-label billed-yearly-label"><strong>$529</strong>/ yearly</div> -->
        <div class="pricing-plan-features ">
            <!-- <strong>Features</strong> -->
            NextStep’s expert recruiting team is here to find your ideal candidate quickly and efficiently.
            <!-- <ul>
                <li :class="[feature == 'blank' ? 'text-white' : '']" class="skeleton"
                    v-for="(feature, i) in item.features" :key="i">
                    {{ feature }}</li>
            </ul> -->
            <a target="_blank" href="https://nextstephiring.com/">
                <img class="margin-top-25 margin-bottom-25" src="\images\NextStep.png">
            </a>
        </div>
        <button @click="select" class="button full-width margin-top-20">Learn more</button>
    </div>
</template>

<script>

export default {

    methods: {
        select() {
            this.$router.push("/nextstep");
        }
    },
}
</script>
<style lang="scss" scoped>
.loading div h3 {
    background-color: #f2f2f2;
    animation: pulse 1s infinite;
}

.loading .button {
    pointer-events: none;
    opacity: 0.3;
}

.loading .skeleton:before {
    content: "";
    display: inline-block;
    width: 100%;
    height: 16px;
    background-color: #f2f2f2;
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0% {
        background-color: #f2f2f2;
    }

    50% {
        background-color: #e6e6e6;
    }

    100% {
        background-color: #f2f2f2;
    }
}
</style>